const INITIAL_STATE = {
    isLoading: true
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_LOADING': {
            return {isLoading: action.payload}
        }
        default:
            return state;
    }
}
